/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { FC, ReactElement, useContext, useEffect, useState } from 'react';
import { getStandings } from '../../services/http/httpService';
import { PrefferencesContext } from '../../context/context';
import { IFootballStandingINternational, IFootballStanding } from '../../interfaces/interfaces';
import { REFRESH_INTERVAL, WIDGET_WIDTH } from '../../config/config';
import TableLoader from '../loader/loader';
import { getGroup, getSeasonIdQuery, trans } from '../../helpers/helperFunctions';

const getStandingsByGroupName = (
  standings: IFootballStandingINternational[],
  groupParam: string
) => {
  return standings.filter((group) => group.stageName.split(' ')[1] === groupParam.toUpperCase());
};

const Table: FC = (): ReactElement | null => {
  const { language, widgetWidth } = useContext(PrefferencesContext);
  const [loading, setLoading] = useState<boolean>(true);
  const [groupStandings, setStandings] = useState<IFootballStandingINternational[]>([]);

  // Fetches standings when a competition is selected manually or on load, and registers refresh
  useEffect(() => {
    const seasonId = getSeasonIdQuery();
    const groupParam = getGroup();
    if (!seasonId || !language) return undefined;
    getStandings(seasonId, language)
      .then((response) => {
        setLoading(false);
        if (groupParam) {
          setStandings(getStandingsByGroupName(response, groupParam));
        } else {
          setStandings(response);
        }
      })
      .catch((e) => {
        console.log('Error fetching standings');
        setLoading(false);
      });

    // Register interval to re-fetch standings
    const standingsInterval = setInterval(() => {
      if (!seasonId || !language) return;
      getStandings(seasonId, language)
        .then((response) => {
          if (groupParam) {
            setStandings(getStandingsByGroupName(response, groupParam));
          } else {
            setStandings(response);
          }
        })
        .catch((e) => {
          console.log('Error fetching standings');
        });
    }, REFRESH_INTERVAL);

    return () => clearInterval(standingsInterval);
  }, [language]);

  return (
    <div>
      {groupStandings.map((group, index) => {
        return (
          <div key={group.stageName + index}>
            <div>
              {createStandingsTable(group.standings, loading, widgetWidth, group.stageName)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

function createStandingsTable(
  standings: IFootballStanding[],
  loading: boolean,
  widgetWidth: number,
  stageName: string
): ReactElement {
  return (
    <div className="table-container">
      <div className="stage-name">{stageName}</div>
      <div className="row-titles">
        <p>{trans('team')}</p>
        <p>{trans('game')}</p>
        <p>{trans('goals')}</p>
        <p>{trans('differencesOfGoals')}</p>
        <p>{trans('points')}</p>
      </div>
      {loading ? (
        <TableLoader viewBox="10 10 1200 720" />
      ) : (
        <table className="standings-table">
          <tbody>
            {standings.map((row, index) => {
              const {
                rank,
                teamLogoUrl,
                teamMicroName,
                matchesPlayed,
                goalsFor,
                goalsAgainst,
                goalDifference,
                contestantName,
                points
              } = row;
              const teamName = widgetWidth <= WIDGET_WIDTH ? teamMicroName : contestantName;
              return (
                <tr key={`${rank}${index}${Math.random()}`}>
                  <td>{`${rank}.`}</td>
                  <td>
                    <img src={teamLogoUrl} alt="Team logo" />
                  </td>
                  <td>{teamName}</td>
                  <td>{matchesPlayed}</td>
                  <td>{`${goalsFor}:${goalsAgainst}`}</td>
                  <td>{goalDifference}</td>
                  <td>{points}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Table;
